import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Grid,
  Typography,
  Avatar,
  InputAdornment,
  TextField,
  Button,
} from "@material-ui/core/";
import { Progress, Select, message  } from 'antd'
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import EmailIcon from "@material-ui/icons/PhoneIphone";
import LockIcon from "@material-ui/icons/Lock";
import { blue } from "@material-ui/core/colors";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

import { fetchCode, getEmailCode } from "../../actions/code";
import { resetPassword, resetPasswordByEmail, resetPasswordSuccess } from "../../actions/auth";
import compose from "recompose/compose";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import bgIcon from "../../assets/images/login-bg.jpg";
import logoIcon from "../../assets/images/logo.png";
import defaultIcon from "../../assets/images/company.png";


const { Option } = Select;
const styles = (theme) => ({
  loginBg: {
    position: 'relative',
    width: "100%",
    height: "100vh",
    background: `url(${bgIcon}) center center / cover`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginShadow: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    background: 'rgba(226,226,226,.25)',
    zIndex: '1'
  },
  loginBox: {
    position: 'relative',
    width: "460px",
    minHeight: "560px",
    padding: "40px",
    background: "rgba(255,255,255, .8)",
    borderRadius: "8px",
    zIndex: '5'
  },
  loginLogo: {
    width: "100%",
    height: "70px",
    textAlign: "right",
    transform: "translate(10px, -10px)",
    "& img": {
      height: "70px"
    }
  },
  boyingAvatar: {
    width: "60px",
    height: "60px",
    marginTop: "20px"
  },
  boyingText: {
    padding: "0px 20px 30px 70px",
    fontSize: "40px",
    color: blue[700],
    marginTop: "-60px"
  },
  loginText: {
    marginTop: "10px",
    fontSize: "24px",
    lineHeight: "36px",
    color: "#333",
    fontWeight: "600"
  },
  subText: {
    fontSize: "14px",
    lineHeight: "21px"
  },
  inputLine: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between'
  },
  inputStyle: {
    width: "100%",
    marginBottom: "24px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderBottom: "1px solid #2b3dcd !important",
      borderRadius: 0
    },
    "& .MuiOutlinedInput-root": {
      paddingLeft: "10px !important",
      height: '50px',
    }
  },
  passwordCheck: {
    width: '50px',
    height: '50px',
    marginLeft: '10px',
    textAlign: 'center',
    lineHeight: '50px',
    fontSize: '16px',
    fontWeight: '600',
    '& .ant-progress-text': {
      color: '#5fe232 !important'
    },
    '&.active2 .ant-progress-text': {
      color: '#16d8fc !important'
    },
    '&.active3 .ant-progress-text': {
      color: '#166cfc !important'
    },
  },
  afterSelect: {
    width: '100px',
    height: '50px',
    marginLeft: '10px',
    display: 'flex',
    alignItems: 'center',
    '& .ant-select': {
      width: '100px !important'
    }
  },
  backLogin: {
    width: '100%',
    color: blue[600],
    textAlign: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  codeButton: {
    position: 'absolute',
    right: '0',
    top: '9px',
    borderRadius: '3px',
    width: "120px",
    height: '32px',
    padding: '0 10px',
    marginLeft: "40px",
    backgroundColor: "#20a263",
    fontSize: "14px",
  },
  loginButton: {
    width: "100%",
    marginBottom: "16px",
    height: "50px",
    borderRadius: theme.spacing(4),
    backgroundColor: "#315de3",
    color: "white",
    fontSize: "20px"
  },
  inputPassword: {
    width: "55%",
  },
 
  comfirmButton: {
    width: "80%",
    marginBottom: "10px",
    height: "40px",
    borderRadius: theme.spacing(4),
    backgroundColor: "#367ddc",
    color: "white",
    fontSize: "20px",
  },
  loginForm: {
    width: "100%",
    marginTop: "10px"
  },
  footer: {
    position: 'absolute',
    zIndex: '10',
    left: '0',
    bottom: '0',
    width: '100%',
    height: '30px',
    zIndex: '100',
    textAlign: 'center',
    fontSize: '13px',
    color: '#fff',
    lineHeight: '30px'
  },
  footerName: {
    marginLeft: '20px'
  },
});

class ResetPassword extends Component {
  state = {
    type: "1",
    password: "",
    password2: "",
    email: '',
    phone: "",
    code: "",
    emailUser: "",
    active: false,
    active2: false,
    active3: false,
    checked: false,
    passwordError: false,
    password2Error: false,
    phoneError: false,
    emailError: false,
    codeError: false,
    pinError: true,
    pinState: false,
    code_type: "reset",
    timer: 60,
    codeNotFetched: false,
  };

  setTimer = () => {
    let timer60 = setInterval(() => {
      this.setState(
        {
          timer: this.state.timer - 1,
        },
        () => {
          if (this.state.timer === 1) {
            clearInterval(timer60);
            this.setState({
              pinState: false,
              timer: 13,
            });
          }
        }
      );
    }, 1000);
  };

  getCode = () => {
    if (this.state.type == '1') {
      this.props.fetchCode(this.state.phone, this.state.code_type);
    } else {
      getEmailCode({
        email: this.state.email
      }).then(res => {
        console.log(123, res)
        this.setState({
          emailUser: res.username
        })
      })
    }
    this.setState(
      {
        pinState: true,
      },
      this.setTimer()
    );
  };
  onChangePassword = (e) => {
    let password = e.target.value
    let active, active2, active3 = false
    if (password.length < 8){
      active = true
      active2 = false
      active3 = false
    } else if (password.length >= 8 && password.length < 10) {
      active = false
      active2 = true
      active3 = false
    } else {
      active = false
      active2 = false
      active3 = true
    }
    this.setState({
      password: password,
      active,
      active2,
      active3,
      passwordError:
        !/^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/.test(
          password
        ),
    });
  };
  phoneBlur = () => {
    let flag = !/^1[3|4|5|6|7|8]\d{9}$/.test(this.state.phone);
    this.setState({
      phoneError: flag,
      pinError: flag,
    });
  };
  emailBlur = () => {
    let flag = !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.email);
    this.setState({
      emailError: flag,
      pinError: flag,
    });
  };
  phoneFocus = () => {
    this.setState({
      pinError: true,
    });
  };
  emailFocus = () => {
    this.setState({
      pinError: true,
    });
  };
  onChangePassword2 = (e) => {
    let password = e.target.value
    this.setState({
      password2: password,
      password2Error: this.state.password === password ? false : true,
    });
  };
  codeBlur = () => {
    this.setState({
      codeError: !/^\d{6}$/.test(this.state.code),
    });
  };
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      checked: false,
    });
  };
  onFocus = () => [
    this.setState({
      active0: false,
      active2: false,
      active3: false,
    }),
  ];

  onSubmit = (e) => {
    if (this.state.type == '1') {
      this.props.resetPassword(
        this.state.phone,
        this.state.code,
        this.state.password
      );
    } else {
      resetPasswordByEmail({
        code: this.state.code,
        email: this.state.email,
        username: this.state.emailUser,
        password: this.state.password
      }).then(res => {
        if (res.access) {
          message.success('修改成功')
          this.props.history.push('/login')
        }
      })
    }
  };

  onChangeType = (value, key) => {
    this.setState({
      type: value,
      pinError: true,
      code: ''
    })
  }

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/" />;
    }
    const classes = this.props.classes;
    return (
      <Fragment>
        <Grid container className={classes.loginBg}>
          <div className={classes.loginShadow}></div>
          <Grid item className={classes.loginBox}>
            <div className={classes.loginLogo}>
              <img src={logoIcon} />
            </div>
            <div>
              <div className={classes.loginText}>忘记密码</div>
            </div>
            <Grid container>
              <div className={classes.loginForm}>
                <div  className={classes.inputLine}>
                  <div className={classes.inputStyle}>
                     {
                      this.state.type == '1' &&
                      <TextField
                        error={this.state.phoneError}
                        helperText={this.state.phoneError ? "11位手机号码" : ""}
                        fullWidth="true"
                        size="small"
                        className={classes.inputStyle}
                        variant="outlined"
                        placeholder="手机号"
                        name="phone"
                        onChange={this.onChange}
                        onFocus={this.phoneFocus}
                        onBlur={this.phoneBlur}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PhoneIphoneIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                     }
                     {
                      this.state.type == '2' &&
                      <TextField
                        error={this.state.emailError}
                        helperText={this.state.emailError ? "邮箱格式不正确" : ""}
                        fullWidth="true"
                        size="small"
                        className={classes.inputStyle}
                        variant="outlined"
                        placeholder="邮箱"
                        name="email"
                        onChange={this.onChange}
                        onFocus={this.emailFocus}
                        onBlur={this.emailBlur}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <EmailIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                     }
                  </div>
                  <div className={classes.afterSelect}>
                    <Select
                      className={classes.select}
                      placeholder="请选择"
                      value={this.state.type}
                      onChange={(e) => this.onChangeType(e)} 
                    >
                      <Option value="1">手机号</Option>
                      <Option value="2">邮箱</Option>
                    </Select>
                  </div>
                </div>
                <div className={classes.inputLine}>
                  <TextField
                    error={this.state.codeError}
                    helperText={this.state.codeError ? "6位数字" : ""}
                    size="small"
                    fullWidth="true"
                    className={classes.inputStyle}
                    name="code"
                    onChange={this.onChange}
                    onBlur={this.codeBlur}
                    variant="outlined"
                    placeholder={this.state.type == '1' ? '手机验证码' : '邮箱验证码'}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <VpnKeyIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.codeButton}
                    size="samll"
                    disabled={this.state.pinError || this.state.pinState}
                    onClick={this.getCode}
                  >
                    {`获取验证码 ${
                      this.state.pinState ? this.state.timer : ""
                    }`}
                  </Button>
                </div>
                <div className={classes.inputLine}>
                  <div className={classes.inputStyle}>
                  <TextField
                    error={this.state.passwordError}
                    helperText={
                      this.state.passwordError
                        ? "至少6位，包含大写字母、小写字母、数字、特殊字符"
                        : ""
                    }
                    fullWidth="true"
                    size="small"
                    variant="outlined"
                    placeholder="登录密码"
                    onChange={this.onChangePassword}
                    type="password"
                    name="password"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  </div>
                  <div className={[classes.passwordCheck, `${this.state.active3 ? 'active3' : (this.state.active2 ? 'active2' : '')}`].join(' ')}>
                    <Progress type="circle" strokeWidth={10} strokeColor={this.state.active3 ? '#166cfc' : (this.state.active2 ? '#16d8fc' : '#5fe232')} percent={ this.state.active3 ? 100 : (this.state.active2 ? 66.66667 : 33.33333) } width={50} format={() => this.state.active3 ? '强' : (this.state.active2 ? '中' : '弱')} />
                  </div>
                </div>
                <div  className={classes.inputLine}>
                  <TextField
                    error={this.state.password2Error}
                    helperText={
                      this.state.password2Error ? "两次密码不匹配" : ""
                    }
                    className={classes.inputStyle}
                    size="small"
                    variant="outlined"
                    placeholder="确认密码"
                    onChange={this.onChangePassword2}
                    type="password"
                    name="password2"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <Button
                  disabled={
                    this.state.phoneError ||
                    this.state.codeError ||
                    this.state.passwordError ||
                    this.state.password2Error ||
                    (this.state.phone.length == 0 && this.state.email.length == 0) ||
                    this.state.code.length == 0 ||
                    this.state.password.length == 0 ||
                    this.state.password2 !== this.state.password ||
                    this.state.codeNotFetched
                  }
                  variant="contained"
                  color="primary"
                  fullWidth="true"
                  onClick={this.onSubmit}
                  className={classes.loginButton}
                >
                  提交
                </Button>
              </Grid>
              <div
                className={classes.backLogin}
                onClick={() => this.props.history.push("/login")}
              >
                返回登录
              </div>
              
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.footer}>
          京ICP备2021001914号  
          <span className={classes.footerName}>北京安楹康思医学科技有限公司</span>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { resetPassword, fetchCode, resetPasswordSuccess })
)(withRouter(ResetPassword));
